import { FormattedMessage } from 'react-intl';
import { Button, Space, Table, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { ContentWrapper, UserAvatar } from '@/components/_common';
import { useEmployees } from '@/core/domain/enterprise/Employees/Employees.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { ColumnsType } from '@/components/_common/InfiniteTable';
import { Employee } from '@/core/domain/enterprise/Employees/Employees.types';
import EditIcon from '@/components/_common/EditIcon';
import { getTableScrollX } from '@/utils/table';
import { useDashboardContext } from '@/contexts/DashboardContexProvider';
import { AuthorityCodesDashboard } from '@/core/domain/enterprise/Authority/Authority.types';

const { Title } = Typography;

function HomeEmployeesTeam() {
  const { dashboardType } = useDashboardContext();

  const { data, isFetching } = useEmployees({
    rows: 6,
    order: 'DESC',
    isActive: true,
  });

  const employees = flatInfiniteData(data);

  const isDefaultDashboard =
    dashboardType === AuthorityCodesDashboard.defaultView;

  const columns: ColumnsType<Employee> = [
    {
      dataIndex: 'name',
      render: (value: string, row) => (
        <Space size="large">
          <UserAvatar gender={row.gender} picture={row.photo} />
          {value}
        </Space>
      ),
      width: 120,
    },
  ];

  if (!isDefaultDashboard) {
    columns.push({
      dataIndex: 'actions',
      width: 50,
      align: 'right',
      fixed: 'right',
      render: (_, record) => (
        <EditIcon redirect={`/app/registry/employees/${record.id}/personal`} />
      ),
    });
  }

  return (
    <ContentWrapper
      style={{
        height: '360px',
        padding: 24,
      }}
    >
      <Space size="large">
        <Title level={4} style={{ margin: 0 }}>
          <FormattedMessage id="dashboard.team" />
        </Title>

        {!isDefaultDashboard && (
          <Link to="/app/registry/employees">
            <Button type="link">
              <FormattedMessage id="commons.entity.viewAll" />
            </Button>
          </Link>
        )}
      </Space>

      <div style={{ overflowX: 'auto', height: '100%' }}>
        <Table<Employee>
          columns={columns}
          dataSource={employees}
          loading={isFetching}
          rowKey={(row) => row.id}
          scroll={{ x: getTableScrollX(columns) }}
          footer={undefined}
          pagination={false}
        />
      </div>
    </ContentWrapper>
  );
}

export default HomeEmployeesTeam;
